import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  dialogContainer: {
    width: '512px',
    overflow: 'hidden',
    borderRadius: '8px',
  },

  content: {
    padding: '40px 36px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
  },

  successTitle: {
    marginTop: '10px',
    fontWeight: 600,
    textAlign: 'center',
  },

  okButton: {
    backgroundColor: '#76BD22',
    color: '#fff',
    padding: '8px 40px',
    textTransform: 'none',
    marginTop: '14px',
    '&:hover': {
      backgroundColor: '#76BD22',
    },
  },
});

export default styles;
export const useStyles = makeStyles(styles);
